import { render } from "./bidangPariwisata.vue?vue&type=template&id=3addb09e"
import script from "./bidangPariwisata.vue?vue&type=script&lang=js"
export * from "./bidangPariwisata.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__